import { gql } from '@apollo/client';

export const CbAccountBalanceFields = gql`
  fragment CbAccountBalanceFields on CbAccountBalance {
    id
    ownerId
    paidBalance
    promoBalance
    totalBalance
    availableToRefund
    negativeBalanceAllowed
  }
`;

export const CbBalanceTransactionFields = gql`
  fragment CbBalanceTransactionFields on CbBalanceTransaction {
    id
    type
    paidAmount
    promoAmount
    paidBalanceAfter
    promoBalanceAfter
    campaignId
    paymentId
    reason
    performedByEmail
    performedById
    performedByName
    createdAt
  }
`;
